import { useEffect, useState } from 'react';
import { useErrorStore } from '../../store/models';

function useOTPError () {
  const errStore = useErrorStore();

  const [error, setError] = useState(null);
  const [isLimitExceeded, setIsLimitExceeded] = useState(false);

  function checkLimitExceeded (errorObj) {
    if (!errorObj) return false;
    const message = errorObj.message || errorObj.code || '';
    return message.toLowerCase().includes('attempt limit exceeded') || message.toLowerCase().includes('user temporarily locked');
  };

  useEffect(() => {
    if (errStore?.authError?.confirmSignIn) {
      const errorData = errStore.authError.confirmSignIn;
      setError({
        ...errorData,
      });
      setIsLimitExceeded(checkLimitExceeded(errorData));
    }
  }, [errStore?.authError?.confirmSignIn]);

  useEffect(() => {
    if (errStore?.authError?.resendForOTP) {
      const errorData = errStore.authError.resendForOTP;
      setError({
        ...errorData,
      });
      setIsLimitExceeded(checkLimitExceeded(errorData));
    }
  }, [errStore?.authError?.resendForOTP]);

  function clearError () {
    setError(null);
    setIsLimitExceeded(false);
  };

  return {
    error,
    clearError,
    isLimitExceeded,
  };
}

export default useOTPError;
